export enum RelationshipSearchType {
    SOURCE = "SOURCE",
    TARGET = "TARGET",
    RECURSIVE = "RECURSIVE"
}
